import { Cancel01Icon } from '@hugeicons/react'

import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'
import { stepProgressPercent } from '@/shared/level-play'
import { Button } from '@/shared/ui/Button'
import { confirmExitLevel } from '@/shared/ui/dialog'
import { LevelPlay } from '@/shared/ui/LevelPlay'
import { ProgressBar } from '@/shared/ui/ProgressBar'

import { DigitalProductQuizQuizHeartsAndCountdown } from './HeartsAndCountdown'
import { useQuizContext } from '../../context'

export const DigitalProductQuizQuizPlayQuestionToolbar = ({ activity }) => {
  const { currentStepIndex, totalSteps } = useQuizContext()
  const router = useRouter()

  const handleBackToQuiz = async () => {
    const isConfirmed = await confirmExitLevel()

    if (isConfirmed) router.push('/quizzes')
  }

  // `currentStepIndex` do quiz agora é base zero, igual ao da jornada — a ponte
  // `fromLegacyQuizIndex` saiu junto com o índice duplicado. As duas toolbars
  // passam a fazer a mesma chamada, sem compensação de domínio.
  const pct = stepProgressPercent({ currentStepIndex, totalSteps })

  return (
    <LevelPlay.Toolbar>
      <div className="w-[125px]">
        <Button
          variant="danger-ghost"
          icon
          onClick={handleBackToQuiz}
          aria-label="Sair do quiz"
          leadingIcon={<Cancel01Icon variant="solid" size={22} />}
        />
        {/* <DigitalProductQuizQuizVouchers
              onUseVoucher={voucherId => handleCompleteQuestion({ voucherId })} />
          */}
      </div>
      <ProgressBar
        value={pct}
        variant="progress"
        size="lg"
        aria-label="Progresso do quiz"
      />
      <div className="w-[125px] flex justify-end">
        <DigitalProductQuizQuizHeartsAndCountdown activity={activity} />
      </div>
    </LevelPlay.Toolbar>
  )
}
